// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZHMPu99pJObAtE {
  border: 1px solid var(--ds-border, #091e4224);
  background-color: var(--ds-surface, #ffffff);
}
.ZHMPu99pJObAtE th {
  width: 200px;
  border: 1px solid var(--ds-border, #091e4224);
}
.ZHMPu99pJObAtE th:first-child {
  width: 450px;
}
@media only screen and (max-width: 920px) {
  .ZHMPu99pJObAtE th {
    width: auto;
    max-width: 200px;
  }
  .ZHMPu99pJObAtE th:first-child {
    width: auto;
    max-width: 250px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `ZHMPu99pJObAtE`
};
export default ___CSS_LOADER_EXPORT___;
